// extracted by mini-css-extract-plugin
module.exports = {"menu":"_11nj3h1vpm7d7iD9i2RGBP"};